import { createAction } from '@reduxjs/toolkit';
import { INITIATE_APPLICATION_SETTINGS } from './actionTypes.js';

export const initiateApplicationSettings = createAction<any>(INITIATE_APPLICATION_SETTINGS);